<template>
 <Head>
    <title> View Skills | {{$page.props.appName}}</title>
    <meta name="description" :content="'View Skills' + $page.props.appName">
  </Head>
    <div class="w-full flex">
        <div
            class="
                bg-black
                border-t border-white
                flex flex-row
                items-center
                text-white
                w-full
            "
        >
            <svg
                class="w-24 h-24 inline"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
                <path
                    d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                ></path>
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                ></path>
            </svg>

            <h1 class="text-3xl font-semibold inline ml-2">
                Skills & Competency Record
            </h1>
        </div>

        <div></div>
    </div>

    <div class="p-3">
    
        <div class="mt-3 flex flex-wrap items-center justify-center">
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2

                "
            >
                <h2 class="font-semibold">Competence Status </h2>
                <pi-chart :part="total"  :width="300" :height="300"></pi-chart>
            </div>
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2
                "
            >
                <h2 class="font-semibold">Expired Levels</h2>
                <p>Expired Levels</p>
                <div
                    class="
                        bg-red-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">{{expired}}</p>
                </div>

                <p>Pending Expires</p>
                <div
                    class="
                        bg-yellow-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">{{pending}}</p>
                </div>
            </div>
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2

                "
            >
                <h2 class="font-semibold">Average</h2>
                <p>Average Target Level</p>
                <div
                    class="
                        bg-red-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">100%</p>
                </div>

                <p>Competency Completion</p>
                <div
                    class="
                        border-2 border-black
                        text-black
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                        bg-indigo-400
                    "
                >
                    <p class="text-3xl">{{100 - total}}%</p>
                </div>
            </div>
        </div>

        <div class="mt-3 mx-3">
            <h1 class="font-bold text-3xl border-b-2 border-black">Skills</h1>
                        <p v-if="selfskills.length==0" class="font-semibold text-2xl text-center">
                            No skills to show!
                        </p>

                        <div v-else>
                            <div v-for="(skillgroup,key) in selfskills" :key="key" class="mt-2 rounded-md  overflow-x-auto">
                                <h2 class="font-bold text-2xl border-b-2 border-black mb-2"> {{key}}</h2>
                                 <table class="p-3 w-full shadow">
                                     <thead class="bg-gray-100 text-left">
                                         <th class="p-1"></th>
                                         <th class="p-1 text-center">Target Definition</th>
                                         <th class="p-1 text-center">Actual Definition</th>
                                         <th class="p-1 text-center">Date Attained</th>
                                         <th class="p-1 text-center">Expiry Date</th>
                                         <th class="p-1"></th>
                                         <th class="p-1"></th>

                                     </thead>
                                     <skill-row v-for="skill in skillgroup" :key="skill.id" :skill="skill"> </skill-row>
                                 </table>
                
                            </div>
                        </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import PiChart from "@/Shared/PiChart"
import SkillRow from "./SkillRow.vue";
import moment from 'moment'
import { Head } from '@inertiajs/inertia-vue3'

export default {
      data() {
    return {
      addSkill : false,
      front_card: '',
      back_card : '',
      form: this.$inertia.form({
         skill_id : null,
         achieved_date : null,
         expiry_date : null,
         front_card : null,
         back_card : null
      }),
    };
  },
    layout: Layout,
    props: {
        staff: Object,
        skills : Object,
        selfskills : Object,
        expired : Number,
        pending : Number,
        total : Number
    },
    components: { PiChart, SkillRow,Head },
};
</script>
